"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscrowIx = void 0;
const common_sdk_1 = require("@orca-so/common-sdk");
const ixs = __importStar(require("./instructions"));
class EscrowIx {
    constructor(ctx, ix) {
        this.ctx = ctx;
        this.ix = ix;
    }
    initializeConfigIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.initializeConfig(this.ctx.program, params);
            return this;
        });
    }
    setTradeConfigAuthorityIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.setTradeConfigAuthority(this.ctx.program, params);
            return this;
        });
    }
    setAmlPolicyAuthorityIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.setAmlPolicyAuthority(this.ctx.program, params);
            return this;
        });
    }
    addArbitratorCertIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.addArbitratorCert(this.ctx.program, params);
            return this;
        });
    }
    addTokenIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.addToken(this.ctx.program, params);
            return this;
        });
    }
    removeTokenIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.removeToken(this.ctx.program, params);
            return this;
        });
    }
    setRenecPriceIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.setRenecPrice(this.ctx.program, params);
            return this;
        });
    }
    updateConfigIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.updateConfig(this.ctx.program, params);
            return this;
        });
    }
    removeArbitratorCertIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.removeArbitratorCert(this.ctx.program, params);
            return this;
        });
    }
    initKycCertIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.initKycCert(this.ctx.program, params);
            return this;
        });
    }
    setKycCertIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.setKycCert(this.ctx.program, params);
            return this;
        });
    }
    makeOrderIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.makeOrder(this.ctx.program, params);
            return this;
        });
    }
    cancelOrderIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.cancelOrder(this.ctx.program, params);
            return this;
        });
    }
    joinSellOrderIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.joinSellOrder(this.ctx.program, params);
            return this;
        });
    }
    callArbitrator(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.callArbitrator(this.ctx.program, params);
            return this;
        });
    }
    releaseIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.release(this.ctx.program, params);
            return this;
        });
    }
    resolveDispute(params) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ix = yield ixs.resolveDispute(this.ctx.program, params);
            return this;
        });
    }
    toTx() {
        const tx = new common_sdk_1.TransactionBuilder(this.ctx.provider.connection, this.ctx.provider.wallet);
        return this.ix ? tx.addInstruction(this.ix) : tx;
    }
}
exports.EscrowIx = EscrowIx;
